var LabelsByAssessment = {
    primary: 'Placement',
    middle: 'Mid-Year',
    finally: 'End-of-Year',
};
var ShortLabelsByAssessment = {
    primary: 'PT',
    middle: 'MOY',
    finally: 'EOY',
};
var LabelsByAssessmentResult = {
    far_below: 'Far below',
    below: 'Below',
    meets: 'Meets',
    exceeds: 'Exceeds',
    tbd: 'TBD',
};
var SummaryLabelsByAssessment = {
    primary: 'Аll assessments results',
    middle: 'MOY growth',
    finally: 'EOY growth',
};
export { LabelsByAssessment, ShortLabelsByAssessment, LabelsByAssessmentResult, SummaryLabelsByAssessment, };
